import axios from 'axios'
import { Modal, message } from 'antd'

const DeleteJobFairVenue = (props) => {
    const { id, name } = props.data

    const handleOk = () => {
        axios.post('/admin/venue/delete', {
            venue_id: id
        })
            .then(function (response) {
                if (response.errcode === 0) {
                    message.success('删除成功！')
                    props.isCancel()
                    props.getVenueData()
                }
            })
            .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
            })
    }

    return (
        <Modal
            title="删除双选会展位"
            open={props.isOpen}
            onOk={handleOk}
            onCancel={props.isCancel}
            cancelText="取消"
            okType='danger'
            okText='删除'>

            <p>正在将
                <span style={{ color: '#005dff' }}>《{name}》</span>
                的双选会展位从列表中移除，此操作不可逆，是否确认删除？
            </p>
        </Modal>
    )
}

export default DeleteJobFairVenue
